import React from 'react';
import Card from '../components/Card';
import StatsCard from '../components/StatsCard';
import Button from '../components/Button';
import LoadingSpinner from '../components/LoadingSpinner';

export default function Statistics({ stats, isLoading }) {
  if (isLoading || !stats) {
    return <LoadingSpinner />;
  }

  const purchaseRate = stats.total_generated > 0 
    ? ((stats.total_purchased / stats.total_generated) * 100).toFixed(1) 
    : 0;
  const usageRate = stats.total_purchased > 0 
    ? ((stats.total_used / stats.total_purchased) * 100).toFixed(1) 
    : 0;
  const revenue = (stats.total_purchased * 0.50).toFixed(2);

  return (
    <div>
      <div className="page-header">
        <h1 className="page-title">Statistics</h1>
        <p className="page-subtitle">Detailed analytics and insights</p>
      </div>

      <Card title="Month: December 2025" actions={
        <Button variant="secondary">Export Report</Button>
      }>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '24px', marginTop: '20px' }}>
          <div>
            <div style={{ fontSize: '13px', color: 'var(--text-secondary)', marginBottom: '8px' }}>
              Total Generated
            </div>
            <div style={{ fontSize: '32px', fontWeight: '700' }}>
              {stats.total_generated?.toLocaleString() || 0}
            </div>
          </div>

          <div>
            <div style={{ fontSize: '13px', color: 'var(--text-secondary)', marginBottom: '8px' }}>
              Total Purchased
            </div>
            <div style={{ fontSize: '32px', fontWeight: '700', color: 'var(--green)' }}>
              {stats.total_purchased?.toLocaleString() || 0}
              <span style={{ fontSize: '16px', color: 'var(--text-secondary)', marginLeft: '8px' }}>
                ({purchaseRate}%)
              </span>
            </div>
          </div>

          <div>
            <div style={{ fontSize: '13px', color: 'var(--text-secondary)', marginBottom: '8px' }}>
              Total Used
            </div>
            <div style={{ fontSize: '32px', fontWeight: '700', color: 'var(--blue)' }}>
              {stats.total_used?.toLocaleString() || 0}
              <span style={{ fontSize: '16px', color: 'var(--text-secondary)', marginLeft: '8px' }}>
                ({usageRate}%)
              </span>
            </div>
          </div>

          <div>
            <div style={{ fontSize: '13px', color: 'var(--text-secondary)', marginBottom: '8px' }}>
              Unused (Paid)
            </div>
            <div style={{ fontSize: '32px', fontWeight: '700' }}>
              {((stats.total_purchased || 0) - (stats.total_used || 0)).toLocaleString()}
            </div>
          </div>

          <div>
            <div style={{ fontSize: '13px', color: 'var(--text-secondary)', marginBottom: '8px' }}>
              Fraud Prevention
            </div>
            <div style={{ fontSize: '32px', fontWeight: '700', color: 'var(--purple)' }}>
              {((stats.total_generated || 0) - (stats.total_purchased || 0)).toLocaleString()}
              <span style={{ fontSize: '16px', color: 'var(--text-secondary)', marginLeft: '8px' }}>
                ({(100 - parseFloat(purchaseRate)).toFixed(1)}%)
              </span>
            </div>
          </div>

          <div>
            <div style={{ fontSize: '13px', color: 'var(--text-secondary)', marginBottom: '8px' }}>
              Revenue
            </div>
            <div style={{ fontSize: '32px', fontWeight: '700', color: 'var(--green)' }}>
              ${revenue}
            </div>
          </div>
        </div>
      </Card>

      <div style={{ marginTop: '24px' }}>
        <Card title="Daily Activity Chart" subtitle="Coming soon">
          <div style={{ padding: '60px', textAlign: 'center', color: 'var(--text-secondary)' }}>
            <p style={{ fontSize: '18px', marginBottom: '8px' }}>📊</p>
            <p>Line graph showing daily stamp generation and usage</p>
          </div>
        </Card>
      </div>

      <div style={{ marginTop: '24px' }}>
        <Card title="Status Breakdown" subtitle="Coming soon">
          <div style={{ padding: '60px', textAlign: 'center', color: 'var(--text-secondary)' }}>
            <p style={{ fontSize: '18px', marginBottom: '8px' }}>🥧</p>
            <p>Pie chart showing distribution of stamp statuses</p>
          </div>
        </Card>
      </div>
    </div>
  );
}
